// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-popup {
  position: relative;
  max-width: 80vw;
  height: auto;
  max-height: calc(100% - 98px);
  background-color: rgb(233, 231, 222);
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: center;
  padding: 30px 20px 50px;
  border-radius: 5px;
  overflow-y: auto;
  overscroll-behavior: contain;
  z-index: 10000;
}

.product-popup__close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  border: none;
  background-color: rgba(122,148,90, 0.4);
  border-radius: 50%;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 20px rgb(122,148,90);
  padding: 25px;
  margin: 0;
}
  
.product-popup__close-button::before,
.product-popup__close-button::after {
  content: '';
  position: absolute;
  width: 80%;
  height: 4px;
  background-color: rgb(233, 238, 227);
  transition: background-color 0.3s ease;
}
  
.product-popup__close-button::before {
  transform: rotate(45deg);
}

.product-popup__close-button::after {
  transform: rotate(-45deg);
}

.product-popup__close-button:hover::before,
.product-popup__close-button:hover::after {
  background-color: #ff5722;
}
  
.product-popup__image {
  width: calc(50% - 20px);
  max-height: 500px;
  object-fit: cover;
  align-self: flex-start;
  border-radius: 5px;
}

.product-popup__description {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-self: start;
  width: calc(50% - 20px);
}

.product-popup__heading {
  text-align: center;
  font-size: 25px;
}
  
.product-popup__about {
  font-size: 18px;
  font-weight: 400;
}
  
.product-popup__ingredients {
  font-size: 18px;
  font-weight: 400;
}
  
.product-popup__modificator {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
}
  
.product-popup__modificator-li {
  list-style: none;
  margin: 0;
  padding: 0;
  display: inline-flex;
  flex-wrap: wrap;
  gap: 5px;
}
  
.product-popup__modifier-checked,
.product-popup__modifier-unchecked {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  border-radius: 5px;
  white-space: nowrap;
  background-color: transparent;
  text-align: center;
  cursor: pointer;
}
  
.product-popup__modifier-checked {
  background-color: rgb(196, 223, 163);
}
  
.product-popup__modifier-unchecked {
  background-color: transparent;
  border: solid 1px rgb(122,148,90);
  border-radius: 5px;
  padding: 3px;
}

.product-popup__amount {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 5px;
  padding: 0;
  margin: 0;
  overflow: hidden;
}
  
.product-popup__amount-li {
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  border-radius: 5px;
  white-space: nowrap;
  background-color: transparent;
  text-align: center;
  cursor: pointer;
  border: solid 1px rgb(122,148,90);
  min-width: 0;
}

@media screen and (max-width: 1100px) {
  .product-popup {
    flex-direction: column;
    gap: 10px;
  }

  .product-popup__image {
    width: 100%;
    height: 300px;
  }

  .product-popup__description {
    width: 100%;
  }
}

@media screen and (max-width: 910px) {}

@media screen and (max-width: 520px) {
  .product-popup {
    max-width: 99vw;
    padding-left: 5px;
    padding-right: 5px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/PopupProducts.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,sCAAsC;;AAEtC;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;AACF","sourcesContent":[".product-popup {\r\n  position: relative;\r\n  max-width: 80vw;\r\n  height: auto;\r\n  max-height: calc(100% - 98px);\r\n  background-color: rgb(233, 231, 222);\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 30px;\r\n  align-items: center;\r\n  padding: 30px 20px 50px;\r\n  border-radius: 5px;\r\n  overflow-y: auto;\r\n  overscroll-behavior: contain;\r\n  z-index: 10000;\r\n}\r\n\r\n.product-popup__close-button {\r\n  position: absolute;\r\n  top: 20px;\r\n  right: 20px;\r\n  width: 40px;\r\n  height: 40px;\r\n  border: none;\r\n  background-color: rgba(122,148,90, 0.4);\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  box-shadow: 0px 0px 20px rgb(122,148,90);\r\n  padding: 25px;\r\n  margin: 0;\r\n}\r\n  \r\n.product-popup__close-button::before,\r\n.product-popup__close-button::after {\r\n  content: '';\r\n  position: absolute;\r\n  width: 80%;\r\n  height: 4px;\r\n  background-color: rgb(233, 238, 227);\r\n  transition: background-color 0.3s ease;\r\n}\r\n  \r\n.product-popup__close-button::before {\r\n  transform: rotate(45deg);\r\n}\r\n\r\n.product-popup__close-button::after {\r\n  transform: rotate(-45deg);\r\n}\r\n\r\n.product-popup__close-button:hover::before,\r\n.product-popup__close-button:hover::after {\r\n  background-color: #ff5722;\r\n}\r\n  \r\n.product-popup__image {\r\n  width: calc(50% - 20px);\r\n  max-height: 500px;\r\n  object-fit: cover;\r\n  align-self: flex-start;\r\n  border-radius: 5px;\r\n}\r\n\r\n.product-popup__description {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  align-self: start;\r\n  width: calc(50% - 20px);\r\n}\r\n\r\n.product-popup__heading {\r\n  text-align: center;\r\n  font-size: 25px;\r\n}\r\n  \r\n.product-popup__about {\r\n  font-size: 18px;\r\n  font-weight: 400;\r\n}\r\n  \r\n.product-popup__ingredients {\r\n  font-size: 18px;\r\n  font-weight: 400;\r\n}\r\n  \r\n.product-popup__modificator {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n  \r\n.product-popup__modificator-li {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: inline-flex;\r\n  flex-wrap: wrap;\r\n  gap: 5px;\r\n}\r\n  \r\n.product-popup__modifier-checked,\r\n.product-popup__modifier-unchecked {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 5px 10px;\r\n  border-radius: 5px;\r\n  white-space: nowrap;\r\n  background-color: transparent;\r\n  text-align: center;\r\n  cursor: pointer;\r\n}\r\n  \r\n.product-popup__modifier-checked {\r\n  background-color: rgb(196, 223, 163);\r\n}\r\n  \r\n.product-popup__modifier-unchecked {\r\n  background-color: transparent;\r\n  border: solid 1px rgb(122,148,90);\r\n  border-radius: 5px;\r\n  padding: 3px;\r\n}\r\n\r\n.product-popup__amount {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  gap: 5px;\r\n  padding: 0;\r\n  margin: 0;\r\n  overflow: hidden;\r\n}\r\n  \r\n.product-popup__amount-li {\r\n  list-style: none;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 3px;\r\n  border-radius: 5px;\r\n  white-space: nowrap;\r\n  background-color: transparent;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  border: solid 1px rgb(122,148,90);\r\n  min-width: 0;\r\n}\r\n\r\n@media screen and (max-width: 1100px) {\r\n  .product-popup {\r\n    flex-direction: column;\r\n    gap: 10px;\r\n  }\r\n\r\n  .product-popup__image {\r\n    width: 100%;\r\n    height: 300px;\r\n  }\r\n\r\n  .product-popup__description {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 910px) {}\r\n\r\n@media screen and (max-width: 520px) {\r\n  .product-popup {\r\n    max-width: 99vw;\r\n    padding-left: 5px;\r\n    padding-right: 5px;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
